import isInBetween from '../isInBetween';
/**
 * Enum to represent different parts of the day
 */ export var PartOfTheDay = /*#__PURE__*/ function(PartOfTheDay) {
    PartOfTheDay["EARLY_MORNING"] = "early_morning";
    PartOfTheDay["MORNING"] = "morning";
    PartOfTheDay["AFTERNOON"] = "afternoon";
    PartOfTheDay["EVENING"] = "evening";
    PartOfTheDay["LATE_NIGHT"] = "late_night";
    return PartOfTheDay;
}({});
/**
 * Util function to get part of the day based on local time
 * @returns  part of the day i.e. early morning, morning,
 * afternoon, evening, late-night etc
 * Used on course page, sample design specs:
 * https://www.figma.com/file/iI9YeDZgcJEB7flqaiX08R/Course-Dash-H2-Milestone-1-2022?node-id=1747%3A200790
 */ const getPartOfTheDay = ()=>{
    const currentHour = new Date().getHours();
    if (isInBetween({
        lower: 4,
        upper: 7,
        toBeCompared: currentHour,
        isLowerBoundInclusive: true
    })) {
        return "early_morning";
    }
    if (isInBetween({
        lower: 7,
        upper: 12,
        toBeCompared: currentHour,
        isLowerBoundInclusive: true
    })) {
        return "morning";
    }
    if (isInBetween({
        lower: 12,
        upper: 17,
        toBeCompared: currentHour,
        isLowerBoundInclusive: true
    })) {
        return "afternoon";
    }
    if (isInBetween({
        lower: 17,
        upper: 23,
        toBeCompared: currentHour,
        isLowerBoundInclusive: true
    })) {
        return "evening";
    }
    return "late_night";
};
export default getPartOfTheDay;
